
<ion-card class="headmodalS">
    <span class="titlemodal">
        {{"terms_and_conditions" | translate}}
    </span>
    <div class="naviB" (click)="closeModal()">
        <ion-icon color="dark" name="close-outline"></ion-icon>
    </div>
</ion-card >
<ion-card class="contentcard bg-light">
    <div [innerHTML]="content"></div>
</ion-card>
<ion-footer class="ion-no-border">
    <ion-card class="headmodalS" >
            <div class="close-gen" (click)="closeModal()">
                {{"cancel" | translate}}
            </div>
      
            <div class="ogen-button" (click)="acceptModal()">
                {{"accept" | translate}}
            </div>
    </ion-card>
</ion-footer>